import React from 'react'

import '@ant-design/compatible/assets/index.css'
import ReactApexChart from 'react-apexcharts'
import { Spinner } from 'react-activity'
import './styles.css'
import { defaultConfigChartPie } from '../../util/chartsUtil'
import empty1 from '../../assets/images/empty1.png'
const PieChart = function(props) {
  const { data, title = '', axisX, axisY } = props
  const options = defaultConfigChartPie(title, data[axisX])
  const series = data[axisY] ? data[axisY].map(item => +item) : []

  return (
    <>
      {!data.isLoading && data[axisX] && data[axisY] && data[axisX].length > 0 && data[axisY].length > 0 && (
        <ReactApexChart options={options} series={series} type="pie" height={360} />
      )}
      {!data.isLoading && data[axisX] && data[axisY] && data[axisX].length === 0 && data[axisY].length === 0 && (
        <>
          <h4>{title}</h4>
          <div className="containerEmpty">
            <img src={empty1} alt={title} className={'imgEmpty'}></img>
            <p>Nenhum dado encontrado</p>
          </div>
        </>
      )}
      {data.isLoading && (
        <div className="card-block">
          <Spinner className="primary-color"></Spinner>
        </div>
      )}
    </>
  )
}

export default PieChart
